import { render, staticRenderFns } from "./TransportVehiclesPage.vue?vue&type=template&id=43aa7211"
import script from "./TransportVehiclesPage.vue?vue&type=script&lang=js"
export * from "./TransportVehiclesPage.vue?vue&type=script&lang=js"
import style0 from "./TransportVehiclesPage.vue?vue&type=style&index=0&id=43aa7211&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports